import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, MenuItem, TextField } from '@mui/material';

import './CreateVectorFocusForm.scss';

function CreateVectorFocusForm({ diseaseVectors, possibleVectorFocus, onSubmit }) {
  const diseaseVectorMenuItems = getDiseaseVectorMenuItems();
  const possibleVectorFocusMenuItems = getPossibleVectorFocusMenuItems();
  const defaultOptionDiseaseVectors = diseaseVectorMenuItems?.[0]?.value;
  const defaultOptionVectorFocus = possibleVectorFocusMenuItems?.[0]?.value;

  function getDiseaseVectorMenuItems() {
    return diseaseVectors || [];
  }

  function getPossibleVectorFocusMenuItems() {
    return possibleVectorFocus || [];
  }

  function validate(values) {
    const errors = {};

    if (!values.description) {
      errors.description = 'Adicione uma descrição';
    }

    if (!values.diseaseVectorId) {
      errors.diseaseVectorId = 'Selecione o vetor da doença';
    }

    if (!values.possibleFocusId) {
      errors.possibleFocusId = 'Selecione o tipo do foco';
    }

    return errors;
  }

  function handleSubmit(values, { setSubmitting }) {
    values.diseaseVector = diseaseVectors.find(item => item.label === values.diseaseVectorId);
    values.possibleFocus = possibleVectorFocus.find(item => item.label === values.possibleFocusId);
    onSubmit(values, { setSubmitting });
  }

  return (
    <Formik
      initialValues={{
        description: '',
        diseaseVectorId: '',
        possibleFocusId: ''
      }}
      validate={validate}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="form">
          <Field
            as={TextField}
            multiline
            maxRows={4}
            className="field"
            name="description"
            label="Descrição"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="name" component="div" />
          <Field
            as={TextField}
            select
            defaultValue={defaultOptionDiseaseVectors}
            className="field select"
            name="diseaseVectorId"
            label="Vetor da doença"
            variant="outlined"
            fullWidth
          >
            {diseaseVectorMenuItems.map((option) => (
              <MenuItem key={option.key} value={option.label} className="menu-item">
                <div className="menu-item-text-wrapper">
                  <span className="text">{option.label}</span>
                </div>
              </MenuItem>
            ))}
          </Field>
          <ErrorMessage name="diseaseVectorId" component="div" />
          <Field
            as={TextField}
            select
            defaultValue={defaultOptionVectorFocus}
            className="field select"
            name="possibleFocusId"
            label="Tipo do foco"
            variant="outlined"
            fullWidth
          >
            {possibleVectorFocusMenuItems.map((option) => (
              <MenuItem key={option.key} value={option.label} className="menu-item">
                <div className="menu-item-text-wrapper">
                  <span className="text">{option.label}</span>
                </div>
              </MenuItem>
            ))}
          </Field>
          <ErrorMessage name="possibleFocusId" component="div" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Enviando ...' : 'Registrar foco'}
          </Button>
        </Form>
      )}
    </Formik>
  );
}

export default CreateVectorFocusForm;
